import { ReactNode, useEffect } from "react"
import { useAuth } from "@/contexts/auth"
import { Navigate, useLocation } from "react-router-dom"
import { toast } from "sonner"
import { Loader2 } from "lucide-react"
;

interface AuthGuardProps {
  children: ReactNode
  requireAuth?: boolean
  allowedRoles?: string[]
}

export function AuthGuard({ 
  children, 
  requireAuth = true,
  allowedRoles
}: AuthGuardProps) {
  const { isAuthenticated, user, isLoadingAuth } = useAuth()
  const location = useLocation()

  useEffect(() => {
  }, [isAuthenticated, user, location.pathname, allowedRoles]);

  // Show loading state while authentication is being checked
  if (isLoadingAuth) {
    return (
      <div className="h-screen flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="h-8 w-8 animate-spin mx-auto mb-4" />
          <p className="text-muted-foreground">Loading authentication...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated and auth is required
  if (requireAuth && !isAuthenticated) {
    
    // Only log the error, no toast message
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // Redirect to dashboard if authenticated and trying to access auth pages
  if (!requireAuth && isAuthenticated) {
    return <Navigate to="/" replace />
  }

  // For routes that require role-based access
  if (requireAuth && isAuthenticated && allowedRoles && user && !allowedRoles.includes(user.role)) {
    toast.error("You don't have permission to access this page");
    return <Navigate to="/" replace />
  }

  // Render children if authentication checks pass
  return <>{children}</>
}

export default AuthGuard
